import { appName } from "@core/schema/names/appName.js";

export function createTitle(title?: string): string {
	if (!title) {
		return appName;
	}
	// Meta titles entered in the admin may already include the "| Commarec" suffix,
	// so strip any trailing occurrences before appending it to avoid duplicates.
	const suffix = `| ${appName}`;
	let base = title.trim();
	while (base.endsWith(suffix)) {
		base = base.slice(0, -suffix.length).trimEnd();
	}
	if (!base) {
		return appName;
	}
	return `${base} | ${appName}`;
}
